<template>
  <section class="login_box" >
    <p class="location_nav"><span class="left">您的位置 : 
    	<router-link to="/Index">首页</router-link>
    	> 注册</span><b class="right">
      <router-link to="/Index">← 返回首页</router-link>
      </b></p>
    <div class="login_form">
      <div class="login_h">
        <b class="left">注册</b>
        <span class="right"><router-link to="/Login">已有账号，立马登录》</router-link></span>
      </div>
      <div class="login_inp_box">
        <p class="inp_name">姓名</p>
        <el-input
          class="login_inp "
          placeholder="姓名"
          v-model="name">
        </el-input>
        <p class="inp_name">工作单位</p>
        <el-input
          class="login_inp "
          placeholder="工作单位"
          v-model="workplace">
        </el-input>
        <p class="inp_name">职务</p>
        <el-input
          class="login_inp "
          placeholder="职务"
          v-model="job">
        </el-input>
        <p class="inp_name">职称</p>
        <el-input
          class="login_inp "
          placeholder="职称"
          v-model="academic_title">
        </el-input>
        <p class="inp_name">联系电话</p>
        <el-input
          class="login_inp "
          placeholder="联系电话"
          v-model="number">
        </el-input>
        <p class="inp_name">邮箱</p>
        <el-input
          class="login_inp "
          placeholder="邮箱"
          v-model="mail">
        </el-input>
        <p class="inp_name">上传证明资料</p>
        <div class="upload_box txt_center" @click="bind_file">
          <i class="el-icon-plus" style="font-size: 24px;margin-top:34px;margin-bottom:12px;color: #C6C6C6;font-weight: 800;"></i>
          <div class="el-upload__tip" style="line-height: 18px;"><span>上传图片</span><br /><small style="color: #CCCCCC">最大1M</small></div>
          <input style="display: none" type="file" value="" name="" id="file_" @change="get_file">
        </div>
        
        <el-button type="primary" class="login_btn"  @click="submit_fn">提交申请</el-button>
      </div>
    </div>
  </section>
</template>

<script>
import { yh_get,yh_post,yh_alert } from "../api/index"
export default {
  data () {
    return {
      height: {
        height: 0
      },
      name : "",
      workplace : "",
      job : "",
      academic_title : "",
      number : "",
      mail: "",
      file: "",
    }
  },
  methods: {
    bind_file() {
      document.getElementById("file_").click();
    },
    get_file() {
      this.file = document.getElementById("file_").files[0];
      console.log(this.file)
    },
    submit_fn() {
      if(this.name == ""){
        this.$alert('请填写用户名', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      } 
      if(this.workplace == ""){
        this.$alert('请填写工作单位', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if(this.job == ""){
        this.$alert('请填写职位', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if(this.academic_title == ""){
        this.$alert('请填写职称', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if(this.number == ""){
        this.$alert('请填写联系电话', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if(this.mail == ""){
        this.$alert('请填写邮箱', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if(this.file == ""){
        this.$alert('请选择证明文件', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      let obj = {
        name : this.name,
        workplace : this.workplace,
        job : this.job,
        academic_title : this.academic_title,
        number : this.number,
        mail: this.mail,
        file: this.file,
      }
      console.log(obj)
      // this.$api.axios_register(obj).then(res => {
          // this.$router.replace("/Index")
      // })
    }
  },
  mounted() {
    // if ((document.body) && (document.body.clientHeight))
    // this.height.height = document.documentElement.clientHeight - 140 + "px";
    // console.log(this.height.height)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_box{
  /* padding-top: 30px; */
  height: auto;
  overflow: hidden;
  width: 1000px;
  margin: 0 auto;
}
.location_nav{
  width: 100%;
  height: 20px;
  padding-top: 30px;
  line-height: 20px;
}
.login_form{
  width:1000px;
  height:auto;
  background: #ffffff;
  margin: 30px auto 80px;
  padding: 30px 90px;
  box-sizing: border-box
}
.login_inp_box{
  width: 350px;
  margin: 0 auto;
}
.login_h{
  width: 350px;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  margin-bottom: 42px;
}
.login_h b{
  font-size: 24px;
}
.login_h span{
  color: #999999
}
.inp_name{
  line-height: 30px;
  margin-top: 15px;
  color: #333333;
}
.upload_box{
  width:126px;
  height:126px;
  background:#f5f5f5;
  border-radius:6px;
  margin-bottom: 30px;
  border:1px dashed #d5d5d5;
}
.login_btn{
  width: 350px;
}
a:-webkit-any-link{
  color: #333333;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue